import { render } from "./ChevronBack.vue?vue&type=template&id=1aecb8d4"
const script = {}
script.render = render

export default script